import { atom } from "recoil";

export const notifications = atom({
  key: "notifications",
  default: [],
});

export const notificationModal = atom({
    key: "notificationModal",
    default: false,
});

export const refreshNotifications = atom({
    key: "refreshNotifications",
    default: false,
});